import BaseWidget from "common/widgets/PromptList/ImagePromptInput";

const ImagePromptInput = BaseWidget.extend({

    init: function() {
        BaseWidget.fn.init.apply(this, arguments);
        if (this.options.model.width && this.options.model.height) {
            // legacy maintain aspect for flex-saved forms loaded in html
            if (this.options.model.maintainAspectRatio) {
                this.input.css("max-width", this.options.model.width);
                this.input.css("max-height", this.options.model.height);
            } else {
                this.input.width(this.options.model.width);
                this.input.height(this.options.model.height);
            }
        }
    },

    getMinSize: function() {
        var minSize = BaseWidget.fn.getMinSize.apply(this, arguments);
        minSize.width = 20;
        minSize.height = 20;
        return minSize;
    },

    updateStyle: function() {
        BaseWidget.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
    },

    updateSize: function() {
        BaseWidget.fn.updateSize.apply(this, arguments);
        this._updateSize();
    },

    _updateStyle: function() {
        this.input.attr("src", this.options.model.imageName);
    },

    _updateSize: function() {
        if (this.options.width && this.options.height) {
            this.input.css({
                width: this.options.width + "px",
                height: this.options.height + "px",
                "max-width": "",
                "max-height": ""
            });
        }
    }
});

kendo.ui.plugin(ImagePromptInput);
export default ImagePromptInput;
